export default __webpack_public_path__ + "static/media/Bauxite.256.e025d386.png";